<template>
  <v-footer color="footer" class="justify-center" style="flex:unset;">
    &copy; MyKet All Rights Reserved.
  </v-footer>
</template>
